import type { PropsWithChildren } from 'react'
import React from 'react'
import Typography from '../Typography/Typography'

function Title({
  children,
}: PropsWithChildren<Record<string, unknown>>): JSX.Element {
  return (
    <Typography component="h1" variant="h5">
      {children}
    </Typography>
  )
}

export default Title
